import { css } from 'lit'

/**To be renamed voyageTobbarStyles, both constant and file name when this is version is to be on edge as well
 */

export const voyageTopbarStylesCloud = [
    css`
        .voyage-topbar {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            width: 100%;
            background: var(--neutrals-grey-10, white);
            user-select: none;
        }

        .voyage-topbar--box-shadow {
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
        }

        .voyage-topbar-wrapper {
            position: relative;
        }

        .logo-wrapper {
            grid-column: 1;
            display: flex;
            align-items: center;
        }

        .name {
            color: var(--primary-blue-900, white);
            font-family: var(--component-heading-ff, 'serif');
            font-size: 20px;
            line-height: 24px;
            font-weight: normal;
            margin: 0 0px 0 24px;
        }

        .logo-divider {
            border-left: 3px solid var(--primary-blue-300, blue);
            width: 1px;
            height: 15px;
            margin: 2px 4px 0px 6px;
        }

        .status-info {
            font-family: MaerskText;
            font-size: 12px;
            display: flex;
            gap: 8px;
            align-items: center;
        }

        .divider {
            border-left: 1px solid var(--neutrals-grey-06, grey);
            height: 16px;
        }

        .app-name {
            color: var(--primary-blue-900, blue);
            font-family: var(--component-heading-ff, 'serif');
            font-size: 20px;
            line-height: 24px;
            font-weight: bold;
        }

        .logo {
            display: flex;
            align-items: center;
            height: 49px;
        }

        .logo-icon {
            height: 25px;
            width: auto;
            margin-left: 5px;
            display: inline-flex;
        }

        .application-links-dropdown {
            position: absolute;
            top: 48px;
            left: 219px;
            min-width: 200px;

            background: var(--neutrals-grey-10, white);
            border: 1px solid var(--neutrals-grey-06, grey);
            box-sizing: border-box;
        }

        .application-info,
        .application-link {
            display: flex;
            align-items: center;

            color: var(--neutrals-grey-03, black);
            font-family: var(--component-paragraph-ff, 'serif');
            font-size: 18px;
            line-height: 24px;
            font-weight: var(--component-paragraph-weight, normal);
            text-decoration: none;
        }

        .link {
            cursor: pointer;
        }

        .application-link > svg,
        .application-info > svg {
            width: 11px;
            height: 13px;
            fill: currentColor;
        }

        .toolbar {
            display: flex;
            align-items: center;
            font-family: MaerskText;
            font-size: 12px;
            gap: 3px;
            margin-right: 16px;
        }

        .connectivity {
            display: flex;
            align-items: center;
            margin-right: 25px;
            gap: 5px;
        }

        .settings,
        .feedback,
        .user {
            cursor: pointer;
            width: 24px;
            height: 24px;
            flex-shrink: 0;
            padding: 0;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .settings svg,
        .user > svg,
        .feedback > svg {
            width: 22px;
            height: 22px;
            fill: var(--neutrals-grey-03, black);
        }

        .user-account-dropdown {
            position: absolute;
            top: 48px;
            right: 15px;
            z-index: 1;
            background: var(--neutrals-grey-10, white);
            border: 1px solid var(--neutrals-grey-07, grey);
            border-radius: 3px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
            box-sizing: border-box;
            padding: 15px;
            line-height: 24px;
        }

        .user-account-info {
            display: flex;
            gap: 10px;
            align-items: center;
        }

        .user > svg {
            width: 22px;
            height: 22px;
            fill: var(--neutrals-grey-03, black);
        }

        .download-option {
            display: flex;
            justify-content: end;
            cursor: pointer;
            margin-top: 20px;
            gap: 20px;
        }

        .application-link {
            padding: 10px 10px 10px 0;
        }

        .version {
            text-transform: uppercase;
            margin-top: -10px;
            border-radius: 6px;
            line-height: 12px;
            padding: 2px 4px 2px 8px;
            font-size: 12px;
            font-family: MaerskText;
        }

        .settings-links-dropdown {
            position: absolute;
            top: 48px;
            right: 15px;
            z-index: 1;
            background: var(--neutrals-grey-10, white);
            border: 1px solid var(--neutrals-grey-07, grey);
            border-radius: 3px;
            box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
            box-sizing: border-box;
        }

        .settings-links-dropdown,
        .settingsEntry {
            color: var(--neutrals-grey-03, black);
            font-family: MaerskText;
            font-size: 13px;
            line-height: 24px;
        }

        .settings-links-dropdown > * {
            border-bottom: 1px solid #cfcfcf;
        }

        .settings-links-dropdown > *:last-child,
        .settings-links-dropdown > a:last-child {
            border-bottom: none;
        }

        .settings-imo {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px;
            gap: 12px;
        }

        .settingsEntry {
            padding: 5px 12px;
            display: flex;
            gap: 9px;
            align-items: center;
            cursor: pointer;
            width: 100%;
        }

        .settingsEntry:first-of-type {
            padding-top: 9px;
        }

        .settingsEntry:last-of-type {
            padding-bottom: 9px;
        }

        .settingsEntry > svg {
            width: 20px;
            height: 16px;
            color: var(--primary-blue-300, white);
            fill: var(--primary-blue-300, white);
        }

        .settings-links-dropdown mc-icon::part(icon) {
            fill: var(--primary-blue-300, white);
        }

        .settingsEntry:disabled {
            cursor: not-allowed;
        }

        .settingsEntry:disabled > mc-icon,
        .settingsEntry:disabled > span {
            opacity: 0.8;
        }

        .settingsEntry:hover:not(:disabled) {
            text-decoration: underline;
        }

        .right {
            grid-column: 4;
            justify-self: right;

            display: flex;
            align-items: center;
        }

        button {
            background: none;
            border: none;
        }

        .release-notes {
            display: block;
            position: absolute;
            top: 100px;
            right: 20px;
            min-width: 600px;
            min-height: 400px;
            background: var(--neutrals-grey-08, white);
            border-style: solid;
            border-width: 1px;
            border-color: black;
        }

        .release-notes-close {
            position: absolute;
            top: 0px;
            right: 10px;
            cursor: pointer;
            fill: var(--neutrals-grey-02, black);
        }

        .release-notes-close > svg {
            width: 10px;
        }

        .release-notes-object {
            font-family: Arial, Helvetica, sans-serif;
            width: 600px;
            height: 400px;
        }

        .forecast {
            display: flex;
            align-items: center;
            fill: currentColor;
            border-radius: 3px;
            padding-right: 5px;
        }

        .forecast[status='green'] {
            color: var(--voyage-good-green, green);
        }

        .forecast[status='yellow'] {
            color: var(--warning-yellow-8, yellow);
        }

        .forecast[status='red'] {
            color: var(--voyage-error-red, red);
        }

        .imoError {
            grid-column: 2;
            color: var(--voyage-error-red, red);
            padding-right: 5px;
            cursor: pointer;
        }

        .forecastIcon {
            height: 13px;
            width: 15px;
            margin: 5px;
        }

        .forecastIcon > svg {
            height: 100%;
            width: 100%;
            margin: 0;
        }

        .low-res-pill {
            justify-self: flex-end;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 56px;
            height: 18px;
            border-radius: 10px;
            margin-left: 5px;
        }

        .low-res-pill span {
            color: white;
        }

        voyage-tooltip {
            --tooltip-background-color: var(--primary-blue-01);
            font-family: MaerskText;
            font-size: 14px;
        }

        .migrate-button {
            margin-left: 10px;
        }

        .migration-panel {
            position: absolute;
            height: 240px;
            width: 423px;
            margin-top: 20px;
        }

        .migration-container {
            display: flex;
            flex-direction: column;
            height: 100%;
            justify-content: space-between;
        }

        .migration-panel-buttons {
            align-self: flex-end;
            position: absolute;
            bottom: 16px;
        }

        .failed-message {
            display: flex;
            box-sizing: border-box;
            align-items: center;
            width: 100%;
            height: 44px;
            background-color: var(--feedback-danger-light, red);
            border-radius: 4px;
            padding: 12px;
            margin-bottom: 6px;
            pointer-events: none;
        }
        .failed-message svg {
            width: 16px;
            margin-right: 14px;
        }

        .network-status-icon {
            display: inline-block;
            width: 24px;
            height: 24px;
        }

        .network-status-icon svg {
            width: 24px;
            height: 24px;
        }

        .online {
            color: #2a941e;
        }

        .offline {
            color: #b80012;
        }
        
        .slow-network {
            color: #eab61b;
        }
    `,
]